import { List, ListItemButton, ListItemText } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import { HeaderMainNav, NavigationGroup, NavigationLink } from '@/graphql/__generated/sdk';

import { menuDrawerStyles } from './Header.styles';
import CustomTypography from './UI/Typography/CustomTypography';
import { colors } from './UI/colors';

export type MenuListItemType = HeaderMainNav | NavigationGroup | NavigationLink;

interface MenuListProps {
	items: NavigationLink[];
	getText: (item: MenuListItemType) => string;
	getHref?: (item: MenuListItemType) => string | undefined;
	hasNextLevel?: (item: MenuListItemType) => boolean;
	onItemClick?: (item: MenuListItemType) => void;
	onLinkClick?: (href: string, linkText: string) => void;
}

const MenuList = ({ items, getText, getHref, hasNextLevel, onItemClick, onLinkClick }: MenuListProps) => {
	const handleLinkClick = (href: string, item: NavigationLink) => {
		if (onLinkClick) {
			onLinkClick(href, getText(item));
		}
	};
	return (
		<List component="div" disablePadding sx={menuDrawerStyles.menuListRoot} id="drawer-links-container">
			{items.map((item, idx) => {
				const nextLevel = hasNextLevel ? hasNextLevel(item as NavigationGroup) : false;
				const href = getHref ? getHref(item) : undefined;

				if (!nextLevel && href) {
					// Render as link if no next level and href exists
					return (
						<ListItemButton
							href={href}
							component="a"
							sx={menuDrawerStyles.menuListItemButton}
							key={idx}
							title={getText(item)}
							onClick={() => handleLinkClick(href, item)}
						>
							<ListItemText sx={menuDrawerStyles.menuListItemText}>
								<CustomTypography
									variant="bodyLBold"
									sx={{ '&.MuiTypography-root': { color: colors.text.secondary } }}
								>
									{' '}
									{getText(item)}
								</CustomTypography>
							</ListItemText>
						</ListItemButton>
					);
				}

				// Render as button for drill-down
				return (
					<ListItemButton
						key={idx}
						onClick={onItemClick ? () => onItemClick(item) : undefined}
						sx={menuDrawerStyles.menuListItemButton}
					>
						<ListItemText sx={menuDrawerStyles.menuListItemText}>
							<CustomTypography
								variant="bodyLBold"
								sx={{ '&.MuiTypography-root': { color: colors.text.secondary } }}
							>
								{getText(item)}
							</CustomTypography>
						</ListItemText>
						{nextLevel && <ChevronRightIcon sx={menuDrawerStyles.menuChevron} />}
					</ListItemButton>
				);
			})}
		</List>
	);
};

export default MenuList;
